export const otpInputStyle={width:'12vw',height:'5.5vh',borderRadius:'6px',border:'solid 1px #808080'}

export const otpContainerStyle={width:'100%',display:'flex',justifyContent:'center'}